import type { GetPermissionListResultDto, PermissionGrantInfoDto } from "@/entities/admin/types"

/** false — скрыть объединения и союзы из UI; код и API остаются. */
export const isAssociationsUiEnabled = true

/** Имена политик модуля ассоциаций и аудита членства (ABP). */
export const isAssociationRelatedPermissionName = (name: string | null | undefined): boolean => {
  if (!name) return false
  return /\.Associations(\.|$)/.test(name)
}

const filterPermissionList = (permissions: PermissionGrantInfoDto[]): PermissionGrantInfoDto[] => {
  if (isAssociationsUiEnabled) return permissions
  return permissions.filter((p) => !isAssociationRelatedPermissionName(p.name))
}

/** Группы и права для отображения в дереве ролей (без ассоциаций при выключенном UI). */
export const filterAssociationPermissionGroupsForDisplay = (
  data: GetPermissionListResultDto | null,
): GetPermissionListResultDto | null => {
  if (!data || isAssociationsUiEnabled) return data
  const groups = (data.groups ?? [])
    .map((group) => ({
      ...group,
      permissions: filterPermissionList(group.permissions ?? []),
    }))
    .filter((group) => (group.permissions?.length ?? 0) > 0)
  return { ...data, groups }
}
